/* eslint-disable import/prefer-default-export -- Named export is re-exported by utils index */
import { ICharacter } from "@next-platform/client-common-core";

import { IDraftChracter } from "@/types";

/**
 * `storageKey` must be the fully resolved key built by `getDraftStorageKey`. Drafts are read and
 * written through the raw `localStorage` so the user suffix is appended exactly once.
 *
 * `isCompleteList` tells the sync whether `apiData` holds every character the user owns. Callers
 * that pass a single paginated page must leave it `false`, otherwise a draft whose character sits
 * on a later page looks deleted. The full-list caller sets it so drafts left behind by characters
 * the user has since deleted stop rendering.
 */
export function syncDraftCharacters(
  moderatedData: IDraftChracter[],
  apiData: ICharacter[],
  lsDraftData: Record<string, IDraftChracter>,
  storageKey: string,
  isCompleteList = false,
) {
  const modifiedDraftData = { ...lsDraftData };
  const deletedIds: string[] = [];

  moderatedData.forEach((draftData: IDraftChracter) => {
    const filteredApiData = apiData.find((characterItem: ICharacter) => characterItem?.id === draftData?.id);
    const isOrphaned = isCompleteList && !filteredApiData;
    const hasModerationChanged =
      filteredApiData != null && filteredApiData?.moderationReport?.moderation_status !== draftData?.moderationReport?.moderation_status;
    if (isOrphaned || hasModerationChanged) {
      delete modifiedDraftData[draftData?.id as string];
      if (draftData?.id) {
        deletedIds.push(draftData.id);
      }
    }
  });

  if (deletedIds.length === 0) {
    return lsDraftData;
  }

  localStorage.setItem(storageKey, JSON.stringify(modifiedDraftData));

  return modifiedDraftData;
}
